import { render, staticRenderFns } from "./PotentialApplicants.vue?vue&type=template&id=0a96e67e&"
import script from "./PotentialApplicants.vue?vue&type=script&lang=js&"
export * from "./PotentialApplicants.vue?vue&type=script&lang=js&"
import style0 from "./PotentialApplicants.vue?vue&type=style&index=0&id=0a96e67e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports